import { ReactNode, useCallback, useMemo, useState } from "react";
import { SideBarContainer } from "../../../../components/SideBarContainer";
import { FormItems } from "../components/FormItems";

export const useOpenSidebar = (reloadData: () => void) => {
  const [openedItem, setOpenedItem] = useState<string | null | undefined>(
    undefined,
  );

  const openSideBar = useCallback((id: string): void => {
    setOpenedItem(id);
  }, []);

  const setShowSideBar = useCallback((_?: boolean) => {
    setOpenedItem(undefined);
  }, []);

  const isShow: boolean = useMemo(
    () => !!openedItem || openedItem === null,
    [openedItem],
  );

  const formWrapper: ReactNode = useMemo(() => {
    const title: string = openedItem ? "Form Details" : "Add Form";

    return (
      <SideBarContainer title={title} setShowSideBar={setShowSideBar}>
        <FormItems
          id={openedItem}
          close={setShowSideBar}
          reloadData={reloadData}
        />
      </SideBarContainer>
    );
  }, [openedItem, setShowSideBar, reloadData]);

  return { isShow, setOpenedItem, openSideBar, formWrapper };
};
